import { render, staticRenderFns } from "./StakingDao.vue?vue&type=template&id=0900848b&"
import script from "./StakingDao.vue?vue&type=script&lang=js&"
export * from "./StakingDao.vue?vue&type=script&lang=js&"
import style0 from "./StakingDao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports